<header class="navbar navbar-fixed-top bg-system">
    <ul class="nav navbar-nav navbar-left" ng-class="{ 'closed-main-menu' : collapseMenuStatus }"
    
        <li class="hidden-xs">
            <a class="navbar-fullscreen toggle-active" href="/customer-orders">
                <img src="img/logo-icon.svg" alt="Hodxpress.com">
            </a>
        </li>
    </ul>

    <ul class="nav navbar-nav navbar-center">
        <p>Hi {{ authenticatedUser.dba_name ? authenticatedUser.dba_name : authenticatedUser.customer_name  }}, Your ID #100{{ authenticatedUser.customer_id }}</p>
    </ul>

    <ul class="nav navbar-nav navbar-right">
        <li class="dropdown dropdown-fuse hidden-xs">
            <a class="pr-0" href="tel:(833) HOD-4466">
                (888) 477-2132 
            </a>
        </li>
        <li class="dropdown dropdown-fuse hidden-xs">
            <a class="pr-0" href="#">
                |
            </a>
        </li>
        <li class="dropdown dropdown-fuse hidden-xs">
            <a class="pr-0" href="mailto:help@hodx.io">
                help@hodx.io
            </a>
        </li>
    </ul>
</header>
